<!--
    描述：企业账户 --- 提现记录表
    时间：2020-12-18
    Created by ws
-->
<template>
    <div class="w-table-layout" ref="table">
        <div class="w-table-header" v-if="roleBtns.includes('txjldc')">
            <!-- txjldc -->
            <el-button type="primary" @click="doExport">导出</el-button>
        </div>
        <div class="w-table-content">
            <el-table border :data="tableData" ref="xTable" highlight-current-row height="480px" class="records-table">
                <el-table-column type="index" label="序号" width="55px" show-overflow-tooltip
                    align="center"></el-table-column>
                <el-table-column prop="createDate" label="创建时间" width="200" align="center"
                    show-overflow-tooltip></el-table-column>
                <el-table-column prop="bizOrderNo" label="提现流水号" width="220" align="center"
                    show-overflow-tooltip></el-table-column>
                <el-table-column prop="amount" label="提现金额 (元)" width="130" header-align="center" align="right"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                        <div>
                            {{ scope.row.amount ? scope.row.amount.toFixed(2) : "0.00" }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="actualAmount" label="实际应到账金额 (元)" width="170" header-align="center" align="right"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                        <div>
                            {{
                                scope.row.actualAmount
                                    ? scope.row.actualAmount.toFixed(2)
                                    : "0.00"
                            }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="fee" label="服务费 (元)" width="120" header-align="center" align="right"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                        <div>
                            {{ scope.row.fee ? scope.row.fee.toFixed(2) : "0.00" }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="bankName" label="银行" min-width="150" align="center"
                    show-overflow-tooltip></el-table-column>
                <el-table-column prop="bankCardNo" label="提现账户" width="220" align="center"
                    show-overflow-tooltip></el-table-column>
                <el-table-column prop="bankCardPro" label="账户类型" width="120" align="center" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <div>
                            {{ scope.row.bankCardPro === 1 ? "对公账户" : "银行卡" }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="status" label="状态" width="120" align="center" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <div :class="getStatus(scope.row.status).className">
                            {{ getStatus(scope.row.status).text }}
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="w-table-footer">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="currentPage" :page-sizes="pageList" :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper" :total="total" size="mini">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import { getWithDrawRecords } from "api/modules/account";
import { exportPlus } from "utils/tools";
import { mapState } from "vuex/dist/vuex.common.js";
export default {
    props: {
        // 企业ID
        bizUserid: {
            type: String,
            default: "",
        },

        // 验证是否是通过审核的
        showEdit: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            tableData: [],
            currentPage: 1,
            pageList: [10, 20, 30, 50, 100],
            pageSize: 10,
            total: 0,
        };
    },
    created() {
        this.bizUserid !== '' ? this.doSearch() : '';
    },
    mounted() {
        // console.log(this.$refs.table.offsetHeight)
    },
    methods: {
        // 初始查询数据
        doSearch() {
            getWithDrawRecords({
                bizUserid: this.bizUserid,
                size: this.pageSize,
                current: this.currentPage,
            })
                .then((res) => {
                    if (res.operationCode === 1) {
                        this.total = parseInt(res.data.total);
                        this.tableData = res.data.records;
                    }
                })
                .catch((err) => {
                    this.total = 0;
                    this.tableData = [];
                });
            return;
            let list = [
                {
                    withdrawalTime: "2020-12-21  17:32:04",
                    amount: 1000,
                    withdrawalObj: "支付宝(中国)网络技术有限公司",
                    bankName: "中国工商银行",
                    accountName: "62321921122312334",
                    status: 1,
                },
                {
                    withdrawalTime: "2020-12-21  13:32:04",
                    amount: 600,
                    withdrawalObj: "支付宝(中国)网络技术有限公司",
                    bankName: "中国工商银行",
                    accountName: "62321921122312334",
                    status: 2,
                },
                {
                    withdrawalTime: "2020-12-21  08:32:04",
                    amount: 800,
                    withdrawalObj: "支付宝(中国)网络技术有限公司",
                    bankName: "中国工商银行",
                    accountName: "62321921122312334",
                    status: 0,
                },
            ];
            this.tableData = list;
            this.total = list.length;
        },

        // 切换显示条数
        handleSizeChange(size) {
            this.pageSize = size;
            this.doSearch();
        },

        // 切换当前页
        handleCurrentChange(cur) {
            this.currentPage = cur;
            this.doSearch();
        },

        // 获取状态文字
        getStatus(status) {
            let obj = {
                text: "",
                className: "",
            };

            if (!status && status !== 0) {
                return obj;
            }

            // 正规流程
            switch (status) {
                case 0:
                    obj.text = "未到账";
                    obj.className = "is-waiting";
                    break;
                case 1:
                    obj.text = "已到帐";
                    obj.className = "is-success";
                    break;
                case 2:
                    obj.text = "提现失败";
                    obj.className = "is-failed";
            }

            return obj;
        },

        // 点击导出
        doExport() {
            if (this.tableData.length == 0) {
                this.$message.warning({ message: "没有要导出的数据!" });
                return;
            }
            let params = {
                columns: [{
                  "type": "seq",
                  "title": "序号",
                  "width": 70,
                  "align": "left",
                  "headerAlign": "left",
                  "visible": true,
                  "forbidCheck": 1,
                  "forbidDrag": 1,
                  "field": "index"
                }, {
                  "field": "createDate",
                  "title": "创建时间",
                  "minWidth": 220,
                  "align": "left",
                  "headerAlign": "left",
                  "visible": true,
                  "forbidCheck": 1,
                  "forbidDrag": 1
                }, {
                  "field": "bidOrderNo",
                  "title": "提现流水号",
                  "minWidth": 100,
                  "visible": true
                }, {
                  "field": "amount",
                  "title": "提现金额",
                  "minWidth": 100,
                  "visible": true
                }, {
                  "field": "actualAmount",
                  "title": "实际应到账金额（元）",
                  "width": 100,
                  "visible": true
                }, {
                  "field": "fee",
                  "title": "服务费",
                  "minWidth": 100,
                  "visible": true
                }, {
                  "field": "bizUserid",
                  "title": "提现会员",
                  "minWidth": 100,
                  "visible": true
                }, {
                  "field": "bankName",
                  "title": "银行",
                  "width": 100,
                  "visible": true
                }, {
                  "field": "bankCardNo",
                  "title": "提现账户",
                  "minWidth": 100,
                  "visible": true
                }, {
                  "field": "bankCardPro",
                  "title": "账户类型",
                  "minWidth": 100,
                  "visible": true
                }, {
                  "field": "status",
                  "title": "状态",
                  "minWidth": 100,
                  "visible": true
                }],
            };

            let path = "/bmPayment/exportList";
            exportPlus(path, params);
        }
    },
    computed: {
        ...mapState('menu', {
            roleBtns: (state) => state.roleBtns,
        }),
    },
    watch: {}
};
</script>

<style scoped lang="less">
.is-success {
    &:before {
        content: "";
        display: inline-block;
        width: 12px;
        height: 12px;
        line-height: 12px;
        margin-right: 10px;
        // vertical-align: middle;
        border-radius: 50%;
        background-color: green;
        -webkit-box-shadow: 0px 0px 4px 0px green;
        box-shadow: 0px 0px 4px 0px green;
    }
}

.is-waiting {
    &:before {
        content: "";
        display: inline-block;
        width: 12px;
        height: 12px;
        line-height: 12px;
        margin-right: 10px;
        // vertical-align: middle;
        border-radius: 50%;
        background-color: orange;
        -webkit-box-shadow: 0px 0px 4px 0px orange;
        box-shadow: 0px 0px 4px 0px orange;
    }

    // color: red;
}

.is-failed {
    &:before {
        content: "";
        display: inline-block;
        width: 12px;
        height: 12px;
        line-height: 12px;
        margin-right: 10px;
        // vertical-align: middle;
        border-radius: 50%;
        background-color: red;
        -webkit-box-shadow: 0px 0px 4px 0px red;
        box-shadow: 0px 0px 4px 0px red;
    }

    // color: red;
}

.w-table-layout {
    display: flex;
    flex-direction: column;

    .w-table-header {
        height: 50px;
        text-align: right;
    }

    .w-table-content {
        flex: 1;
    }

    .w-table-footer {
        height: 50px;
        flex-shrink: 0;
        position: relative;
    }
}
</style>
